import { render, staticRenderFns } from "./AddressModal.vue?vue&type=template&id=696bf998&scoped=true&"
import script from "./AddressModal.vue?vue&type=script&lang=js&"
export * from "./AddressModal.vue?vue&type=script&lang=js&"
import style0 from "./AddressModal.vue?vue&type=style&index=0&id=696bf998&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696bf998",
  null
  
)

export default component.exports